export default __webpack_public_path__ + "static/media/men-2.748e2550.jfif";